import format from 'date-fns/format';
import React, {useEffect} from 'react'
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useGetInvoiceQuery } from '../../../api/invoiceApiSlice';
import Block from '../../../components/Block';
import { Loader } from '../../../components/components';
import { formatNumber } from '../../../components/Format';
import Icon from '../../../components/Icon';
import Kpi from '../../../components/publisher/kpis/Kpi';
import PercentGaugeKpi from '../../../components/publisher/kpis/PercentGaugeKpi';
import Table from '../../../components/tables/Table';
import Pagination from "../../../components/tables/Pagination";
import useCustomTable from '../../../components/tables/useCustomTable';
import Tabs from '../../../components/Tabs';
import Title from '../../../components/Title';
import {useControlledTabs} from "../../../components/Tabs";
import { KpisContainer } from '../../../components/metrics/Kpis';

const InvoiceKpis = ({ kpis }) => {
  const { data_vendor_amount=0, publisher_amount_rate=0, publisher_amount=0, gross_rate=0, gross=0 } = kpis
	const { t } = useTranslation();

  return (
    <KpisContainer>
      <Kpi icon={'income'} value={formatNumber(data_vendor_amount)} title={t("invoices.data_vendor_amount")}/>
      <PercentGaugeKpi value={publisher_amount_rate*100} title={t("invoices.publisher_amount")}/>
      <Kpi icon={'cost'} value={formatNumber(publisher_amount)} title={t("invoices.publisher_amount")} ></Kpi>
      <PercentGaugeKpi value={gross_rate*100} title={t("invoices.gross")}/>
      <Kpi icon='gross' value={formatNumber(gross)} title={t("invoices.gross")} ></Kpi>
    </KpisContainer>
  )
}

const PublisherTab = ({publishers = []}) => {
  const {t} = useTranslation()
  const {year, month} = useParams();
  const history = useHistory();

  const onRowClick = (row) => history.push({
    pathname: `/publishers/${row.id}/revenues/${year}/${month}`,
    state: {onBackPath: location.pathname, onBackTab: "publishers"}
  })
  const {
    tableProps,
    paginationProps
  } = useCustomTable({
    sortable: true,
    paginate: true
  })
  const columns = [{
    Header: 'Publisher',
    accessor: 'name',
    sortType: 'caseInsensitiveString'
  },{
    Header: t('invoices.status'),
    Cell: ({row}) => ( row.original.final ? t("incomes.final") : t("incomes.draft")),
    accessor: 'final'
  },{
    Header: t('invoices.mrg'),
    accessor: 'mrg',
    format: 'price',
    formatOptions: {digits: 2}
  },{
    Header: t('invoices.rev_share_amount'),
    accessor: 'rev_share_amount',
    format: 'price',
    formatOptions: {digits: 2}
  }, {
    Header: t('invoices.amount'),
    accessor: 'amount',
    format: 'price',
    formatOptions: {digits: 2}
  }
  ];

  return(<>
    <Title>
      <Button href={`/v1/invoices/${year}/${month}/publishers.csv`}>
        <Icon icon='csv' text={t("download")} />
      </Button>
    </Title>
    <Block className="mb-0">
      <Table
        data={publishers}
        columns={columns}
        onRowClick={onRowClick}
        {...tableProps} />
    </Block>
    <Pagination {...paginationProps}/>
  </>)
}

const VendorTab = ({vendors = []}) => {
  const {t} = useTranslation()
  const {year, month} = useParams();
  const history = useHistory();
  const location = useLocation();
  const onRowClick = (row) => history.push({
    pathname: `/data_vendors/${row.id}/revenues/${year}/${month}`,
    state: {onBackPath: location.pathname, onBackTab: "vendors"}
  })

  const {
    tableProps,
    paginationProps
  } = useCustomTable({
    sortable: true,
    paginate: true
  })
  const columns = [{
    Header: 'Vendor',
    accessor: 'name'
  },{
    Header: t('invoices.status'),
    Cell: ({row}) => ( row.original.final ? t("incomes.final") : t("incomes.draft")),
    accessor: 'final'
  },{
    Header: t('invoices.data_vendor_amount'),
    accessor: 'amount',
    format: 'price',
    formatOptions: {digits: 2}
  }
  ];

  return(<>
    <Title>
      <Button href={`/v1/invoices/${year}/${month}/data_vendors.csv`}>
        <Icon icon='csv' text={t("download")} />
      </Button>
    </Title>
    <Block className="mb-0">
      <Table
        data={vendors}
        columns={columns}
        onRowClick={onRowClick}
        {...tableProps} />
    </Block>
    <Pagination {...paginationProps}/>
  </>)
}

const MonthlyFinancials = (props) => {
  const {t} = useTranslation();
  const {year, month} = useParams();
  const formattedDate = format(new Date(year, (month-1), 1), 'MMMM yyyy')
  const {data = {}, isSuccess, isLoading} = useGetInvoiceQuery({year, month})
  const [tabProps,] = useControlledTabs("vendors", props)
  const { data_vendor_amount=0, publisher_amount=0} = data
  const gross = data_vendor_amount - publisher_amount
  const publisher_amount_rate = data_vendor_amount == 0 ? 0 : publisher_amount/data_vendor_amount
  const gross_rate = data_vendor_amount == 0 ? 0 : gross/data_vendor_amount

return ( <>
    <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
      <Title main={t("invoice")} sub={formattedDate} backPath={'/finance'}>
        <Button href={`/v1/invoices/${year}/${month}.csv`}>
          <Icon icon='csv' text={t("download")} />
        </Button>
      </Title>
      <InvoiceKpis kpis={{ data_vendor_amount, publisher_amount_rate, publisher_amount, gross_rate, gross }}/>
      <Tabs {...tabProps}>
        <VendorTab as={"vendors"} icon={"organisation"} vendors={data.data_vendors}/>
        <PublisherTab as={"publishers"} icon={"mobile"} publishers={data.publishers}/>
      </Tabs>
    </Loader>
  </> );
}

export default MonthlyFinancials;
